const lowercaseLibrary = 'abcdefghijklmnopqrstuvwxyz';
const uppercaseLibrary = 'ABCDEFGHIJKLMNOPWRSTUVWXYZ';
const numbersLibrary = '0123456789';
const symbolsLibrary = '!@#$%^&*-_=+\\|:;\',.\<>/?~';


export class PasswordGenerator {

  static generate(length: number = 16, lowercase: boolean = true, uppercase: boolean = true, numbers: boolean = true, symbols: boolean = true): string {
    let attemptCount = 0;
    const maxAttempt = 100;
    let password = '';

    while (attemptCount < maxAttempt) {
      password = this._generate(length, lowercase, uppercase, numbers, symbols);
      if (this._validatePassword(password)) {
        break;
      }
      attemptCount += 1;
    }

    return password;
  }

  private static _generate(length: number = 16, lowercase: boolean = true, uppercase: boolean = true, numbers: boolean = true, symbols: boolean = true): string {
    const dictionary = [].concat(
      lowercase ? lowercaseLibrary.split('') : [],
      uppercase ? uppercaseLibrary.split('') : [],
      numbers ? numbersLibrary.split('') : [],
      symbols ? symbolsLibrary.split('') : [],
    );

    let generatedPassword = '';
    for (let i = 0; i < length; i++) {
      generatedPassword += dictionary[Math.floor(Math.random() * dictionary.length)];
    }

    return generatedPassword;
  }

  private static _validatePassword(password: string): boolean {
    if (!password) {
      return false;
    }

    if (password.length <= 6) {
      return false;
    }

    if (!/\d/g.test(password)) {
      return false;
    }

    if (!/[A-Z]/g.test(password)) {
      return false;
    }

    if (!/[a-z]/g.test(password)) {
      return false;
    }

    return true;
  }
}
